import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { VideoRating } from './video-rating';
import { getVideoSelector } from 'components/video-box/selectors';
import { rateVideoRequestAction } from './actions';
import { RateVideoRepository } from './repository';
import { CtPrivacyRepository } from 'common/api/models';

/**
 * Rating is expressed in scale from 0 to 100
 * This rule is followed by bot average and user ratings.
 */
export const RateVideo = () => {
  const dispatch = useDispatch();
  const { id, userRating, ratingAvg } = useSelector(getVideoSelector);

  const isPublic = CtPrivacyRepository.isPublic();
  const sessionRating = RateVideoRepository.fetchFromSession(id);
  const rating = isPublic && sessionRating ? parseInt(sessionRating.value, 10) : userRating || 0;
  const readonly = isPublic && !!sessionRating;

  const onRate = (value) => {
    const newRating = value * 20;
    RateVideoRepository.persistInSession(id, newRating);
    dispatch(rateVideoRequestAction(id, newRating));
  };

  return (
    <VideoRating
      averageRating={ratingAvg} // from 0 to 100
      userRating={rating} // from 0 to 100
      onRate={onRate}
      readonly={readonly}
    />
  );
};
